import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { ImageStyle, ImageSize } from './style'

const Avatar = (props) => {
    const { user, size, url } = props
    const imageClass = classNames(ImageStyle, ImageSize[size])

    return (
        <div className={imageClass}>
            <img className={imageClass} src={url} alt={user} />
        </div>
    )
}

Avatar.propTypes = {
    user: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    url: PropTypes.string,
}

export default Avatar
